import "./productList.css";
import Product from "../product/Product";
import { PRODUCTS } from "../../products";

const ProductList = () => {
  return (
    <div className="pl">
      <div className="pl-texts">
        <h1 className="pl-title">My Work</h1>
        <p className="pl-desc">
         This is a creative portfolio that suits just the kind of needs you have been waiting for.
          Beautiful landing pages, exciting web apps & a whole lot more awaits
          inside.
        </p>
      </div>
      <div className="pl-list">
      {PRODUCTS.map((item) => (
          <Product key={item.id} img={item.img} link={item.link} title ={item.title}/>
        ))}
      </div>
        <div className="pl-more"><a href="https://github.com/PrinceRequiem7?tab=repositories">See more on my Github</a></div>
    </div>
  );
};

export default ProductList;